export default "__VITE_ASSET__BxLof61l__"